import * as React from 'react';

interface FixedCommentsButtonProps {
    onClick: () => void;
    selectedCommentsCount: number;
}

export const FixedCommentsButton = (props: FixedCommentsButtonProps) => {
    return (
        <button id="FixedComments" className="btn btn-primary" type="button" onClick={() => props.onClick()}>
            Fixed Comments&nbsp;
            <span id="SelectedCommentsCountBadge" className="badge badge-info">{props.selectedCommentsCount}</span>
        </button>
    );
}
